var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.hasCertificate
      ? _c("div", [
          _vm.ambit === _vm.ambits.profile
            ? _c("div", [
                _c("h3", [_vm._v("Firma Simple - Proveedor Signapis")]),
                _vm._m(0),
                _c("p", [
                  _vm._v(
                    " Comunícate con tu administrador de sistema para que te habilite. "
                  )
                ])
              ])
            : _c(
                "div",
                [
                  _c("ActiveSignSignapiExterno", {
                    attrs: { configurations: _vm.requestData, user: _vm.user },
                    on: { activate: _vm.activate }
                  })
                ],
                1
              )
        ])
      : _vm._e(),
    _vm.hasCertificate
      ? _c("div", [
          _c("div", { staticClass: "row justify-content-center mb-3" }, [
            _c("div", { staticClass: "col-lg-8 col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Firma Electrónica Simple - Signapis")
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("p", [
                        _c("strong", [_vm._v("Usuario:")]),
                        _vm._v(" " + _vm._s(_vm.user.nombre))
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Correo:")]),
                        _vm._v(" " + _vm._s(_vm.user.correo))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _vm._m(1),
                      _c("p", [
                        _c("strong", [_vm._v("Estado:")]),
                        _c(
                          "span",
                          {
                            class: _vm.isActive ? "text-success" : "text-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.isActive ? "Activa" : "Inactiva") +
                                " "
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._m(2)
                ])
              ])
            ])
          ]),
          _vm.ambit === _vm.ambits.profile
            ? _c(
                "div",
                [
                  _c("ConfigureStamp", {
                    attrs: {
                      prefix: "ssignapi",
                      proveedor: "S_SignAPI_E",
                      tipoFirma: "firmaSimple",
                      user: _vm.user
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("PreviewStamp", {
                    attrs: {
                      prefix: "ssignapi",
                      proveedor: "S_SignAPI_E",
                      tipoFirma: "firmaSimple",
                      user: _vm.user
                    }
                  })
                ],
                1
              )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(" Para comenzar a operar con "),
      _c("b", [_vm._v("Firma Simple Electrónica")]),
      _vm._v(
        ", tu administrador debe habilitarte en el sistema. El enrolamiento se realiza directamente en la plataforma de "
      ),
      _c("b", [_vm._v("Signapis")]),
      _vm._v(". ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("strong", [_vm._v("Proveedor:")]), _vm._v(" Signapis")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("small", { staticClass: "text-muted" }, [
          _vm._v(
            " El enrolamiento y gestión de credenciales se realiza directamente en la plataforma de Signapis. "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }